import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTrigger,
} from '@design-system/Sheet';
import { InfoIcon } from 'lucide-react';
import { Image } from '@design-system/Image';
import { getBoostersAndBlockersImageUrl } from '@/utils/nutrition/getImageUrl';

export interface InfoSheetProps {
  title: string;
  description: string;
  imageUrl?: string;
  mode?: string;
  'data-testid'?: string;
}

export const InfoSheet: React.FC<InfoSheetProps> = ({
  title,
  description,
  imageUrl = null,
  mode = 'dark',
  'data-testid': testId,
}) => {
  return (
    <Sheet data-testid={testId}>
      <SheetTrigger className="mx-1.5 items-center" data-testid="infoSheet-trigger">
        <span data-testid="infoSheet-triggerSpan">
          <InfoIcon
            className="h-4 w-4 -mb-[3px]"
            aria-label={`Information about ${title}`}
            data-testid="infoSheet-icon"
          />
        </span>
      </SheetTrigger>
      <SheetContent className={mode} data-testid="infoSheet-content">
        <SheetHeader data-testid="infoSheet-header">
          {imageUrl && (
            <div className="flex justify-center" data-testid="infoSheet-imageContainer">
              <Image
                className="w-[11.25rem] h-[11.25rem] object-cover"
                src={getBoostersAndBlockersImageUrl(imageUrl)}
                alt={title}
                data-testid="infoSheet-image"
              />
            </div>
          )}
          <SheetDescription className="pl-0 flex flex-col" data-testid="infoSheet-description">
            <span className="typography-h1 text-primary" data-testid="infoSheet-title">{title}</span>
            <span className="typography-body text-secondary whitespace-pre-line pt-4" data-testid="infoSheet-descriptionText">
              {description}
            </span>
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
